<div id="inspections-container" class="secondary-background-color">
    <div class="section-title-container">
        <h2 class="section-title">Inspecciones</h2>
    </div>

    <div class="inspections-general-container">
        @for (card of cards.slice(0,2); track $index) {

            <app-inspections-card [card]="card"></app-inspections-card>
        }
    </div>
    <div class="inspections-general-container">
        @for (card of cards.slice(2, 4); track $index) {

            <app-inspections-card [card]="card"></app-inspections-card>
        }
    </div>
</div>
